import * as types from "../types/campaignTargetType";

const initialState = {
  isLoading: false,
  isError: null,
  campaignTargetTypeEdit: { isOpen: false, campaignTargetType: {} },
  data: {},
};

export default function reducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case types.IS_LOADING:
      return { ...state, isLoading: payload };
    case types.IS_ERROR:
      return { ...state, isError: payload };
    case types.DATA:
      return { ...state, data: payload };
    case types.CAMPAIGN_TARGET_TYPE_EDIT:
      return { ...state, campaignTargetTypeEdit: payload };
    default:
      return state;
  }
}
